import { createSelector } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

import { MetricsApiLogFilterParams } from 'dashboard/redux/slices/metrics-api-logs';
import { RootState } from 'dashboard/redux/store';

const getApiLogFilters = (state: RootState) => state.metricsApiLogs.filters;

export const getAdjustedFilters = createSelector(
  [getApiLogFilters],
  (filters: MetricsApiLogFilterParams) => {
    // Initialize to 1 day when empty
    if (filters.createdAtEnd == null || filters.createdAtStart == null) {
      return {
        ...filters,
        createdAtStart: DateTime.local().startOf('day').toISO(),
        createdAtEnd: DateTime.local().endOf('day').toISO(),
      };
    }

    return filters;
  },
);
